import React, { useState, useContext, useEffect } from "react";
import doctor from "../../assets/images/doctor_dummy.jpg";
import DoctorProvider from "../../Provider/DoctorProvider";
import DocotTimingPopup from "../../UI/DocotTimingPopup/DocotTimingPopup";
import { useNavigate, useParams } from "react-router-dom";
import Spinder from "../../UI/Spiner/Spinder";
import { Breadcrumb } from "antd";
import ClinicDetailsCard from "../../UI/ClinicDetailsCard/ClinicDetailsCard";
import Appointment from "./Appointment";
import Meta from "../../Meta/Meta";
const DoctorProfile = () => {
  const { slug } = useParams();
  console.log("slug", slug);
  const [openTimer, setOpenTimer] = useState(false);
  const navigate = useNavigate();
  const { doctorData, setDoctorData, getDoctorData, doctorLoader } =
    useContext(DoctorProvider);
  useEffect(() => {
    if (slug) {
      getDoctorData(slug); // Pass the slug as an argument to getClinicData
    }
  }, [slug]); // Run when slug changes

  console.log("doctorData", doctorData);
  console.log('slug',slug);
  return (
    <>
      <Meta slug={slug} />
      <section className="my-[5vh]">
        {doctorLoader ? (
          <Spinder />
        ) : (
          <div className="container">
            <div className="mb-[4vh]">
              <Breadcrumb
                separator="/"
                items={[
                  {
                    title: "Home",
                    href: "/",
                  },
                  {
                    title: "Doctor",
                    href: "/app/doctor",
                  },
                  {
                    title: `Dr. ${doctorData?.doctor?.name}`,
                  },
                ]}
              />
            </div>
            <div className="flex flex-col lg:flex-row gap-[40px]">
              <div className="hidden lg:block w-full lg:w-[calc(30%-20px)]">
                {doctorData?.doctor?.image ? (
                  <img
                    src={`${process.env.REACT_APP_BASE}${doctorData?.doctor?.image}`}
                    alt="First Clinic Image"
                    className="w-full h-auto"
                  />
                ) : (
                  <img
                    src={doctor}
                    alt="Placeholder Clinic Image"
                    className="w-full h-auto"
                  />
                )}
              </div>
              <div className="w-full lg:w-[calc(70%-20px)]">
                <h1 className="font-secondary font-medium text-[4rem]">
                  Dr. {doctorData?.doctor?.name}
                </h1>
                <p className="font-primary font-light font-thin text-[14px] mt-3">
                  {`Year of Experience - ${
                    doctorData?.doctor?.experience
                  } year${doctorData?.doctor?.experience > 1 ? "s" : ""}`}
                </p>
                <div className="block lg:hidden my-[20px]">
                  {doctorData?.doctor?.image ? (
                    <img
                      src={`${process.env.REACT_APP_BASE}${doctorData?.doctor?.image}`}
                      alt="First Clinic Image"
                      className="w-full h-auto"
                    />
                  ) : (
                    <img
                      src={doctor}
                      alt="Placeholder Clinic Image"
                      className="w-full h-auto"
                    />
                  )}
                </div>

                {/* <h3 className="font-secondary text-primary font-bold text-[20px] my-[20px]">
                  About the Doctor:
                </h3>
                <p className="font-primary font-thin text-[1.6rem] mt-8 text-[#666363] text-justify lg:text-left">
                  {doctorData?.doctor?.description}
                </p> */}
                <h3 className="font-secondary text-primary font-bold text-[20px] my-[20px]">
                  Specialist
                </h3>
                <ul className="flex gap-[10px]">
                  {doctorData?.doctor?.specialization?.map((item, index) => (
                    <li
                      key={index}
                      className="bg-[#E7FFFC] px-[10px] py-[5px] border-primary border-[1px] font-normal text-[16px] rounded-lg"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
                <div className="flex flex-col md:flex-row gap-[5vw]">
                  <div>
                    <h3 className="font-secondary font-bold text-[20px] text-primary my-[2rem]">
                      Languages Spoken
                    </h3>
                    <ul className="flex gap-[10px]">
                      {doctorData?.doctor?.language?.map((item, index) => (
                        <li
                          key={index}
                          className="bg-[#E7FFFC] px-[10px] py-[5px] border-primary border-[1px] font-normal text-[16px] rounded-lg"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h3 className="font-secondary font-bold text-[20px] text-primary my-[2rem]">
                      Doctor Timing
                    </h3>
                    <div
                      className="inline border border-primary font-medium text-center  mx-auto cursor-pointer text-primary px-8 py-4 rounded-lg text-[14px] hover:bg-primary hover:text-white transition-all duration-300 ease-in-out"
                      onClick={() => setOpenTimer(true)}
                    >
                      Working Hours
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-[5vh]">
              <h3 className="font-secondary font-medium text-[20px] mb-[2rem]">
                Clinics tie up with
              </h3>

              {doctorData?.clinic?.map((clinic) => (
                <ClinicDetailsCard
                  key={clinic.id}
                  data={clinic}
                  doctorName={doctorData?.doctor?.name}
                  appointment={true}
                />
              ))}
            </div>
            {/* <div className="my-[10vh]">
              <h3 className="font-secondary font-medium text-[20px]">
                Disclaimer
              </h3>
              <p className="font-primary font-thin text-[1.6rem] mt-8 text-[#666363] text-justify lg:text-left">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Adipisci dolores omnis minima quaerat esse et reprehenderit
                cumque dolor. Aliquam cum ipsa vitae soluta at accusantium fugit
                possimus ipsum tenetur fugiat?
              </p>
            </div> */}
            <DocotTimingPopup
              open={openTimer}
              setOpen={setOpenTimer}
              clinicTiming={doctorData?.clinic}
            />
          </div>
        )}
        <Appointment />
      </section>
    </>
  );
};

export default DoctorProfile;
